// extracted by mini-css-extract-plugin
export default {"label":"account_label__ONvk7","phone":"account_phone__ztwOl","phoneInput":"account_phoneInput__cSKIi"};